<prox-main [parent]="this" [showBack]="true" [bodyTemplate]="bodyTemplate"></prox-main>

<ng-template #bodyTemplate>
  <div class="qb-list-actions items-center">
    <div class="flex flex-col gap-1">
      <p-floatlabel variant="in">
        <p-select [(ngModel)]="templateType" inputId="templateType" [options]="templateTypes" optionLabel="name"
          (onChange)="onTemplateTypeChange()" styleClass="w-48" variant="filled" />
        <label for="templateType">Template Type</label>
      </p-floatlabel>
      <div *ngIf="!isEventView()" class="flex items-center gap-2 mt-1">
        <p-checkbox [(ngModel)]="showInactive" [binary]="true" inputId="showInactive"
          (onChange)="onShowInactiveChange()"></p-checkbox>
        <label for="showInactive" class="text-sm text-gray-600 cursor-pointer">Show Inactive Templates</label>
      </div>
    </div>

    <ng-container *ngIf="!isEventView()">
      <p-button (onClick)="onAdd()" [disabled]="!canAdd()" label="Add Template" icon="pi pi-plus" size="small" />
      <p-button (onClick)="onCopy()" [disabled]="!canCopy()" label="Copy Template" icon="pi pi-copy" size="small" />
    </ng-container>

    <ng-container *ngIf="isEventView()">
      <div class="flex items-center gap-4 ml-4 text-sm text-gray-600">
        <span class="flex items-center gap-1">
          <i class="pi pi-globe text-gray-500"></i>
          <span>Global</span>
        </span>
        <span class="flex items-center gap-1">
          <i class="pi pi-pencil text-emerald-500"></i>
          <span>Account-specific</span>
        </span>
        <span class="flex items-center gap-1">
          <i class="pi pi-plus text-gray-400"></i>
          <span>No template</span>
        </span>
      </div>
    </ng-container>

    <p-fileUpload *ngIf="isGlobalAdmin" mode="basic" name="uploadTemplates" chooseIcon="pi pi-upload"
      accept="application/json" [maxFileSize]="1000000" (uploadHandler)="uploadHander($event)" [auto]="true"
      [customUpload]="true" chooseLabel="Upload Templates" styleClass="p-button-sm" />
    <p-button *ngIf="isGlobalAdmin" (onClick)="downloadSelected()" label="Download Selected Templates" icon="pi pi-download"
      size="small" />
  </div>

  <div class="qb-layout-grid" *ngIf="isPageReady">
    <prox-ag-grid [gridOptions]="gridOptions" [hasFooter]="false"
      [rowData]="isEventView() ? eventRows : templates"></prox-ag-grid>
  </div>

  <!--
    DEPRECATED 2026-05-15: Email Wrapper Templates UI hidden.
    The Cerberus shell (server/Proximity.Api/Helpers/EmailTemplate.cs) now provides
    the only email header/footer; admin-authored EmailHeader/EmailFooter templates
    are no longer needed. Code kept intact for reversibility — flip the `false`
    below back to `isEventView() && isPageReady` to restore the UI.
    See Docs/Email-Templating-Strategy.md.
  -->
  <div *ngIf="false" class="mt-4 pt-4 p-4 border-t border-gray-300">
    <div class="flex items-center gap-2 mb-3">
      <i class="pi pi-envelope text-lg text-gray-600"></i>
      <span class="font-semibold text-gray-700">Email Wrapper Templates</span>
      <span class="text-sm text-gray-500">(applied to all outgoing emails)</span>
    </div>

    <div class="flex gap-6">
      <!-- Email Header -->
      <div class="flex items-center gap-3 p-3 bg-white rounded border min-w-64">
        <div class="flex-grow">
          <div class="font-medium text-gray-700">Email Header</div>
          <div class="text-sm text-gray-500">
            <ng-container *ngIf="hasWrapperTemplate(NotificationEventEnum.EmailHeader)">
              <i class="pi"
                [ngClass]="isWrapperTemplateGlobal(NotificationEventEnum.EmailHeader) ? 'pi-globe text-gray-500' : 'pi-pencil text-emerald-500'"></i>
              {{ isWrapperTemplateGlobal(NotificationEventEnum.EmailHeader) ? 'Global' : 'Account-specific' }}
            </ng-container>
            <ng-container *ngIf="!hasWrapperTemplate(NotificationEventEnum.EmailHeader)">
              <i class="pi pi-times-circle text-gray-400"></i>
              No template
            </ng-container>
          </div>
        </div>
        <p-button (onClick)="onEditWrapperTemplate(NotificationEventEnum.EmailHeader)"
          [icon]="hasWrapperTemplate(NotificationEventEnum.EmailHeader) ? 'pi pi-pencil' : 'pi pi-plus'"
          [label]="hasWrapperTemplate(NotificationEventEnum.EmailHeader) ? 'Edit' : 'Add'" size="small"
          [outlined]="true" />
        <p-button
          *ngIf="hasWrapperTemplate(NotificationEventEnum.EmailHeader) && !isWrapperTemplateGlobal(NotificationEventEnum.EmailHeader)"
          (onClick)="onDeleteWrapperTemplate(NotificationEventEnum.EmailHeader)" icon="pi pi-trash" size="small"
          [outlined]="true" severity="danger" pTooltip="Delete account-specific template (reverts to global)" />
      </div>

      <!-- Email Footer -->
      <div class="flex items-center gap-3 p-3 bg-white rounded border min-w-64">
        <div class="flex-grow">
          <div class="font-medium text-gray-700">Email Footer</div>
          <div class="text-sm text-gray-500">
            <ng-container *ngIf="hasWrapperTemplate(NotificationEventEnum.EmailFooter)">
              <i class="pi"
                [ngClass]="isWrapperTemplateGlobal(NotificationEventEnum.EmailFooter) ? 'pi-globe text-gray-500' : 'pi-pencil text-emerald-500'"></i>
              {{ isWrapperTemplateGlobal(NotificationEventEnum.EmailFooter) ? 'Global' : 'Account-specific' }}
            </ng-container>
            <ng-container *ngIf="!hasWrapperTemplate(NotificationEventEnum.EmailFooter)">
              <i class="pi pi-times-circle text-gray-400"></i>
              No template
            </ng-container>
          </div>
        </div>
        <p-button (onClick)="onEditWrapperTemplate(NotificationEventEnum.EmailFooter)"
          [icon]="hasWrapperTemplate(NotificationEventEnum.EmailFooter) ? 'pi pi-pencil' : 'pi pi-plus'"
          [label]="hasWrapperTemplate(NotificationEventEnum.EmailFooter) ? 'Edit' : 'Add'" size="small"
          [outlined]="true" />
        <p-button
          *ngIf="hasWrapperTemplate(NotificationEventEnum.EmailFooter) && !isWrapperTemplateGlobal(NotificationEventEnum.EmailFooter)"
          (onClick)="onDeleteWrapperTemplate(NotificationEventEnum.EmailFooter)" icon="pi pi-trash" size="small"
          [outlined]="true" severity="danger" pTooltip="Delete account-specific template (reverts to global)" />
      </div>
    </div>
  </div>

</ng-template>